import { Theme, theme as originTheme } from '@chakra-ui/react'
import { DeepPartial } from '../../../common/types'

interface NucbaAlert extends DeepPartial<Theme['components']['Alert']> {}

// Chakra uses Alert Component for toast

export const Alert: NucbaAlert = {
  variants: {
    'top-accent': (props: any) => {
      const { colorScheme: c } = props
      if (c !== 'red') {
        // use original definition for all color schemes except "blue"
        return originTheme.components.Alert.variants?.subtle(props)
      }
      return {
        container: {
          bg: '#F7DBE5',
          color: 'nucba.gray',
          borderColor: 'nucba.primary',
        },
        icon: {
          color: 'nucba.primary',
        },
      }
    },
    'left-accent': (props: any) => {
      const { colorScheme: c } = props
      if (c !== 'blue') {
        // use original definition for all color schemes except "blue"
        return originTheme.components.Alert.variants?.subtle(props)
      }
      return {
        container: {
          bg: 'rgba(255, 255, 255, 0.16)',
          color: '#F7FAFC',
          borderColor: 'rgba(255, 255, 255, 0.64)',
        },
        icon: {
          color: 'rgba(255, 255, 255, 0.64)',
        },
      }
    },
  },
}
